// extracted by mini-css-extract-plugin
export default {"container":"VendorName_container__ZEe7k","container2":"VendorName_container2__NaSXo"};